import React from 'react';
import Intent from './intent.jsx';
import SelectionIndicators from './selectionIndicator.jsx';
import * as constants from '../js/constants.js';
var classNames = require('classnames');


class IntentGate extends React.Component {

  constructor(props) {
    super(props);
    let selectedIntents = [];

    if (this.props.currentPage === constants.PROJECTS_PAGE && this.props.selectedProjectTypes) {
      selectedIntents = this.props.selectedProjectTypes;
    } else if (this.props.currentPage === constants.SOURCES_PAGE && this.props.selectedSourceTypes) {
      selectedIntents = this.props.selectedSourceTypes;
    }

    this.state = {
      selectedIntents,
      selectionCounter: selectedIntents.length,
      hoveredIntent: null
    };
  }

  handleSelection = (intent) => {
    let selectedIntents = this.state.selectedIntents;

    if (selectedIntents.length <= 3) {
      if (selectedIntents.includes(intent)) {
        const index = selectedIntents.findIndex(entry => entry === intent);
        selectedIntents.splice(index, 1);
      } else if (selectedIntents.length !==3) {
        selectedIntents.push(intent);
      }
      this.setState({selectedIntents, selectionCounter: selectedIntents.length});
    }
  }

  handleHover = (hoveredIntent) => {
    if (!hoveredIntent) {
      this.setState({hoveredIntent: null});
    } else {
      this.setState({hoveredIntent: hoveredIntent});
    }
  }

  handleContinue = () => {
    if (this.state.selectionCounter > 0) {
      this.props.onContinue(this.state.selectedIntents);
    }
  }

  getDescriptionContent() {
    if (!this.state.hoveredIntent) {
      return (
          <div className='intent-gate-card-hover'>
            <div className='hover-img' />
            {/*<img src="../dist/img/project-hover.png"/>*/}
          </div>
      );
    } else {
      return (
          <div className='intent-gate-card-hover'>
            <div className='intent-gate-card-desc-name'>{this.state.hoveredIntent.name}</div>
            <div className='intent-gate-card-description'>{this.state.hoveredIntent.description}</div>
          </div>
      );
    }
  }

  render() {
    return (
      <div>
        {this.props.intents && this.renderContent()}
      </div>
    );
  }

  renderContent = () => {
    return (
      <div className='intent-gate-content'>
        <div className='intent-gate-question-header'>
          <div className='intent-gate-question'>{this.props.title}</div>
          <div className='intent-gate-sub-title'>{this.props.subTitle}</div>
        </div>
        {this.props.currentPage === constants.PROJECTS_PAGE ?
          this.renderProjectTypeContent() :
          this.renderSourceTargetTypeContent()
        }
        {this.renderContinueButtonAndSelectionIndicators()}
      </div>
    );
  };

  renderProjectTypeContent = () => {
    return (
      <div className="project-panel">
        <div className='intent-gate projects-card-container'>
          {this.renderIntents()}
        </div>
        <div className='description-card-container'>
          {this.getDescriptionContent()}
        </div>
      </div>
    );
  };

  renderSourceTargetTypeContent = () => {
    return (
      <div className='intent-gate sources-card'>
          {this.renderIntents()}
          <div className='connectors'>
            <div className='connectors-text'>{this.props.content.sourceTargetType.findOutMore}</div>
            <a href="https://www.informatica.com/products/cloud-integration/connectivity/connectors.html" target="_blank">
              <span className='connectors-icon' />
          </a>
          </div>
        </div>
    );
  };

  renderIntents = () => {
    const containerClasses = classNames({
      'intents-container': true,
      'disable-selection': this.state.selectionCounter > 2
    });

    return (
      <div className={containerClasses}>
        { this.props.intents.map(this.renderIntent) }
      </div>
    );
  };

  renderIntent = intent => {
    return (
      <Intent
        tag={intent.tag}
        name={intent.name}
        image={intent.imageUrl}
        intent={intent}
        handleHover={this.handleHover}
        handleSelection={this.handleSelection}
        isSelected={this.state.selectedIntents.includes(intent.tag)} />
    );
  };

  renderContinueButtonAndSelectionIndicators = () => {
    const continueButtonClasses = classNames({
      'continue-button': true,
      'continue-button-disables': this.state.selectionCounter < 1
    });
    return (
      <div className='intent-gate-button-and-indicator'>
        <button className={continueButtonClasses} onClick={this.handleContinue}
          disabled={this.state.selectionCounter === 0}>{this.props.footer.continue}
                </button>
        <SelectionIndicators text={this.props.footer.selection} selectionCounter={this.state.selectionCounter}></SelectionIndicators>
      </div>
    );
  };
}

export default IntentGate;
